import { GiCrossedBones, GiHamburgerMenu } from "react-icons/gi";
import { Button } from "reactstrap";

const SidebarToggler = ({
  isOpen,
  setisOpen,
  responsiveClassName,
  iconColor,
}) => {
  return (
    <Button
      onClick={() => setisOpen((prev) => !prev)}
      className={`${responsiveClassName} justify-content-center toggler-color bg-transparent border-transparent`}
      style={{
        transition: "0.3s linear all",
      }}
    >
      {!isOpen ? (
        <GiHamburgerMenu size={20} color={iconColor} />
      ) : (
        <GiCrossedBones size={20} color={iconColor} />
      )}
    </Button>
  );
};

export default SidebarToggler;
